import {ReactNode} from "react";

interface CardProps {
    title: string;
    children: ReactNode;
    className?: string;
    colSpan?: 1 | 2 | 3 | 'full';
    fillHeight?: boolean;
}

/**
 * Card component with consistent styling
 * Can be used for all content sections
 */
export const Card = ({ title, children, className = '', colSpan = 1, fillHeight = true }: CardProps) => {
    // Map colSpan to appropriate Tailwind classes
    const colSpanClass = {
        1: 'col-span-1',
        2: 'col-span-1 md:col-span-2',
        3: 'col-span-1 md:col-span-3',
        'full': 'col-span-full'
    }[colSpan];

    return (
        <div className={`${colSpanClass} ${className}`}>
            <div className={`bg-white rounded-lg shadow-sm border border-slate-200 overflow-hidden ${fillHeight ? 'h-full' : ''}`}>
                <div className="bg-blue-900 px-4 py-3">
                    <h2 className="text-white font-medium">{title}</h2>
                </div>
                <div className="p-4">
                    {children}
                </div>
            </div>
        </div>
    );
};